module.exports = __webpack_public_path__ + "img/04 - Condominio_das_Americas_AereaPiscina.3a1e6955.jpg";